import * as React from "react"
import { connect } from "react-redux"
// First way to import
import { FormattedMessage, intlShape } from "react-intl"
import { SyncLoader } from "react-spinners"

class AwesomeComponent extends React.Component<
  { language: string },
  {
    loading: boolean
  }
> {
  private static contextTypes = {
    intl: intlShape
  }
  constructor(props) {
    super(props)
    this.state = {
      loading: true
    }
  }

  public render() {
    return (
      <div className="container">
        <div className="row">
          <div
            className="col-12 text-center"
            style={{ minHeight: "500px", paddingTop: 250 }}
          >
            <div className="sweet-loading">
              <SyncLoader
                sizeUnit={"px"}
                size={15}
                color={"#e56727"}
                loading={this.state.loading}
              />
            </div>
            <p className="text-center">
              {this.props.language === "en"
                ? "Please Wait..."
                : "กรุณารอสักครู่..."}
            </p>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    language:
      state.Language && state.Language.language ? state.Language.language : "th"
  }
}

export default connect(mapStateToProps)(AwesomeComponent)



// WEBPACK FOOTER //
// ./src/components/utility/loader.tsx